import { motion } from "framer-motion";
import { Play } from "lucide-react";

const MIX_IMG =
  "https://images.unsplash.com/photo-1594623930572-300a3011d9ae?auto=format&fit=crop&w=1400&q=80";

const SOUNDCLOUD_EMBED =
  "https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/boilerroom&color=%23ff3b1d&inverse=true&auto_play=false&show_user=true";

const tracklist = [
  { n: "001", title: "WAREHOUSE TRANSMISSION", dur: "62:14" },
  { n: "002", title: "CONCRETE FREQUENCIES", dur: "58:03" },
  { n: "003", title: "NIGHT SHIFT / 4AM CUT", dur: "74:41" },
  { n: "004", title: "SIGNAL BLEED", dur: "49:57" },
];

export default function Mixes() {
  return (
    <section id="mixes" data-testid="mixes-section" className="border-b border-white/15">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative min-h-[420px] lg:min-h-0 border-b lg:border-b-0 lg:border-r border-white/15 overflow-hidden group">
          <img
            src={MIX_IMG}
            alt="Close-up of DJ mixer knobs"
            className="absolute inset-0 w-full h-full object-cover grayscale contrast-125 group-hover:scale-105 transition-transform duration-700 ease-out"
            data-testid="mixes-image"
          />
          <div className="absolute inset-0 bg-black/40" />
          <div className="absolute inset-0 scanline" />
          <div className="absolute top-6 left-6 font-mono-x text-[11px] tracking-[0.3em] text-white/70 uppercase" data-testid="mixes-overline">
            [01] — MIXES
          </div>
          <h2 className="absolute bottom-6 left-6 right-6 font-mono-x font-extrabold uppercase tracking-tighter leading-[0.9] text-5xl sm:text-6xl" data-testid="mixes-title">
            PRESSURE
            <br />
            <span className="text-stroke">ON WAX</span>
          </h2>
        </div>

        <div className="p-6 sm:p-10 flex flex-col justify-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="border border-white/15"
            data-testid="soundcloud-embed"
          >
            <iframe
              title="ANTS DON'T SLEEP on SoundCloud"
              width="100%"
              height="166"
              scrolling="no"
              frameBorder="no"
              allow="autoplay"
              src={SOUNDCLOUD_EMBED}
            />
          </motion.div>

          <div className="border-t border-l border-white/15" data-testid="tracklist">
            {tracklist.map((t, i) => (
              <motion.div
                key={t.n}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className="group flex items-center justify-between border-r border-b border-white/15 px-5 py-4 hover:bg-white transition-colors duration-200 cursor-pointer"
                data-testid={`track-${t.n}`}
              >
                <div className="flex items-center gap-5">
                  <span className="font-mono-x text-[10px] tracking-[0.2em] text-[#ff3b1d]">
                    {t.n}
                  </span>
                  <span className="font-mono-x text-sm sm:text-base font-bold uppercase tracking-tight group-hover:text-black transition-colors duration-200">
                    {t.title}
                  </span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="font-mono-x text-[10px] tracking-[0.2em] text-white/40 group-hover:text-black/60 transition-colors duration-200">
                    {t.dur}
                  </span>
                  <Play
                    size={14}
                    className="text-white/60 group-hover:text-black transition-colors duration-200"
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
